import { getDefaultAsyncWrapperObj } from "@ane/core/lib/models";
import { loadRootWorkspaceEpicReducer, loadWorkspaceMigrationEpicReducer } from "./GetWorkspace.epics.js";
const defaultReducerState = {
  workspace: getDefaultAsyncWrapperObj(),
  migration: getDefaultAsyncWrapperObj()
};
const workspaceReducer = (state = defaultReducerState, action) => {
  state = loadRootWorkspaceEpicReducer.reduxChange(state, action);
  state = loadWorkspaceMigrationEpicReducer.reduxChange(state, action);
  return state;
};
const GetWorkspaceReducersMapObject = {
  workspace_data: workspaceReducer
};
export {
  GetWorkspaceReducersMapObject,
  GetWorkspaceReducersMapObject as default,
  defaultReducerState,
  workspaceReducer
};
//# sourceMappingURL=GetWorkspace.ducks.js.map
